// extracted by mini-css-extract-plugin
export default {"section":"DeviceAddLayout_section__4m+zL","title":"DeviceAddLayout_title__I4if9","buttonContainer":"DeviceAddLayout_buttonContainer__lkFlH","button":"DeviceAddLayout_button__TcEUX"};